module.exports = __webpack_public_path__ + "img/CT.Bridges_.Superstructure.GFRP_Modular_Footbridge.GFRP.3878d6b3.png";